import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  subHeading: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    marginRight: theme.spacing(1.125),
  },
  subHeadingReadOnly: {
    color: theme.palette.primary.light,
    fontSize: '14px',
  },
  pricingTitle: {
    display: 'flex',
  },
  infoIcon: {
    color: theme.palette.icon.main,
    marginTop: theme.spacing(0.75),
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  companyDetailSubHead: {
    marginBottom: theme.spacing(2),
  },
  companyDetailRow: {
    display: 'flex',
  },
  plans: {
    marginTop: theme.spacing(2),
  },
  addBtncontainer: {
    marginTop: theme.spacing(6),
  },
  textAlign: {
    textAlign: 'left',
  },
  planSectionRow: {
    border: `1px solid ${theme.palette.detailedOfferBorder.main}`,
    borderRadius: '4px',
    padding: theme.spacing(3),
    margin: theme.spacing(2, 0),
  },
  planSectionRowContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  trash: {
    color: theme.palette.labraIcon.main,
    cursor: 'pointer',
  },
  descriptionTitle: {
    fontSize: '12px',
    color: theme.palette.text.secondary,
  },
  description: {
    fontSize: '16px',
    color: theme.palette.textField.dark,
    margin: `${theme.spacing(0.25, 0)} !important`,
  },
  selectField: {
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  inputLabel: {
    '&.MuiFormLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
  },
  menuRoot: {
    '&.MuiMenuItem-root': {
      fontSize: '13px',
      color: theme.palette.headerTitle.main,
    },
    '&.MuiListItem-gutters': {
      padding: theme.spacing(1.5),
    },
    '&.MuiListItem-root.Mui-selected': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
    '&.MuiListItem-button:hover': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
  },
  icon: {
    '&.MuiSelect-icon': {
      color: theme.palette.text.tertiary,
    },
  },
  formWidth: {
    width: '100%',
    minWidth: '135px',
  },
  closeIconButton: {
    padding: theme.spacing(0),
    margin: theme.spacing(-2, 0, -2, 0),
    height: '20px',
  },
  closeIcon: {
    '&.MuiSvgIcon-root': {
      width: '20px',
      height: '20px',
      color: theme.palette.icon.main,
      fill: 'currentColor',
    },
  },
  headerTitle: {
    color: theme.palette.textField.main,
    fontSize: '12px',
    fontWeight: 400,
  },
  rowText: {
    color: theme.palette.textField.dark,
    fontSize: '16px',
    fontWeight: 400,
  },
  tableHader: {
    borderBottom: `1px solid ${theme.palette.detailedOfferBorder.main}`,
  },
  tableCell: {
    padding: `${theme.spacing(3, 2, 2, 1)} !important`,
    lineHeight: '1.1rem',
    border: 'none',
    verticalAlign: 'baseLine',
  },
  readOnlyTableCell: {
    padding: `${theme.spacing(1)} !important`,
  },
  metering: {
    marginTop: theme.spacing(5),
  },
  userMinMaxRow: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  userLabel: {
    minWidth: '170px',
  },
  userInput: {
    width: '200px',
  },
  billingPrice: {
    width: '50%',
  },
  checkboxLeft: {
    marginLeft: `${theme.spacing(-1.5)} !important`,
  },
  tableInput: {
    '&.MuiFormControl-root': {
      width: '220px',
    },
  },
  alignMiddel: {
    verticalAlign: 'middle',
  },
}))
